
import { defineComponent, computed } from "vue";

export default defineComponent({
  name: "GeographySection",
  props: {
    geography: { type: Object, required: true },
    loading: { type: Boolean, default: false },
    loaded: { type: Boolean, default: false },
    error: { type: String, default: null },
  },
  setup(props) {
    const top = computed(() => (props.geography.newUsersByCountry ?? []).slice(0, 10));
    const series = computed(() => [
      { name: "New users", data: top.value.map((x: any) => Number(x.value)) },
    ]);
    const chartOptions = computed(() => ({
      chart: { toolbar: { show: false }, background: "transparent" },
      plotOptions: { bar: { horizontal: true, borderRadius: 4 } },
      xaxis: {
        categories: top.value.map((x: any) => x.name),
        labels: { style: { colors: "#fff" } },
      },
      yaxis: { labels: { style: { colors: "#fff" } } },
      tooltip: { theme: "dark" },
      dataLabels: { enabled: false },
      colors: ["#F50242"],
    }));
    return { series, chartOptions };
  },
});
